<!-- ═══════════ SALUTATION DU JOUR ═══════════ -->
<div class="db-greeting">
  <div class="db-greeting-left">
    <span class="db-greeting-salut">{{ greeting }},&nbsp;<strong>{{ prenomUtilisateur }}</strong></span>
    <span class="db-greeting-date">
      <i class="fal fa-calendar-day"></i> {{ dateAujourdhui }}
    </span>
  </div>
  <div class="db-greeting-right">
    <a routerLink="/suivi-live" class="db-shortcut">
      <i class="fal fa-street-view"></i>
      <span>Suivi live</span>
      <span class="db-live-dot"></span>
    </a>
    <a routerLink="/reclamations" class="db-shortcut db-shortcut--warn"
       *ngIf="(vueGlobale?.incidentsOuverts || 0) > 0">
      <i class="fal fa-exclamation-triangle"></i>
      <span>{{ vueGlobale.incidentsOuverts }} incident(s)</span>
    </a>
    <a routerLink="/commande/lister" class="db-shortcut">
      <i class="fal fa-boxes"></i>
      <span>Commandes</span>
    </a>
  </div>
</div>

<!-- ═══════════ TOP KPIs ═══════════ -->
<section class="stats-grid">
  <div class="stat-card stat-card--teal">
    <div class="stat-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="20" x2="18" y2="10"></line>
        <line x1="12" y1="20" x2="12" y2="4"></line>
        <line x1="6" y1="20" x2="6" y2="14"></line>
      </svg>
    </div>
    <div class="stat-info">
      <span class="stat-label">Solde d'ouverture</span>
      <p class="stat-number">{{ formaterMontant(statistiques.soldeOuverture) }}</p>
      <span class="stat-unit">FCFA</span>
    </div>
  </div>

  <div class="stat-card stat-card--indigo">
    <div class="stat-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="12" y1="1" x2="12" y2="23"></line>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
      </svg>
    </div>
    <div class="stat-info">
      <span class="stat-label">Transactions du jour</span>
      <p class="stat-number">{{ formaterMontant(statistiques.transactionsDuJour) }}</p>
      <span class="stat-unit">FCFA</span>
      <span class="stat-badge">{{ statistiques.nombreCommandesJour }} commande(s)</span>
    </div>
  </div>

  <div class="stat-card stat-card--orange">
    <div class="stat-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
        <line x1="12" y1="22.08" x2="12" y2="12"></line>
      </svg>
    </div>
    <div class="stat-info">
      <span class="stat-label">En attente de livreur</span>
      <p class="stat-number">{{ statistiques.nombreCommandesEnAttenteDeLivreur ?? statistiques.nombreCommandesEnAttente ?? 0 }}</p>
      <span class="stat-unit">commande(s)</span>
    </div>
  </div>

  <div class="stat-card stat-card--green">
    <div class="stat-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
    </div>
    <div class="stat-info">
      <span class="stat-label">Revenu net</span>
      <p class="stat-number">{{ formaterMontant(statistiques.revenuNet) }}</p>
      <span class="stat-unit">FCFA</span>
    </div>
  </div>
</section>

<!-- ═══════════ ÉVOLUTION 30 JOURS (sparklines) ═══════════ -->
<section class="dash-section" *ngIf="!chargementEvolution && (evolution30j?.length || 0) > 0">
  <div class="dash-section-header">
    <div class="dash-section-title">
      <div class="dash-section-icon dash-section-icon--blue">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      </div>
      <h3>Évolution sur 30 jours</h3>
    </div>
  </div>
  <div class="sparklines-grid">
    <div class="sparkline-card">
      <div class="sparkline-header">
        <span class="sparkline-label">Commandes créées</span>
        <strong class="sparkline-total">{{ totalEvolution('nbCommandes') }}</strong>
      </div>
      <div echarts [options]="optionsSparkline('nbCommandes', '#3b82f6')" class="sparkline-chart"></div>
    </div>
    <div class="sparkline-card">
      <div class="sparkline-header">
        <span class="sparkline-label">Livraisons réussies</span>
        <strong class="sparkline-total">{{ totalEvolution('nbLivraisons') }}</strong>
      </div>
      <div echarts [options]="optionsSparkline('nbLivraisons', '#10b981')" class="sparkline-chart"></div>
    </div>
    <div class="sparkline-card">
      <div class="sparkline-header">
        <span class="sparkline-label">Revenu (FCFA)</span>
        <strong class="sparkline-total">{{ totalEvolution('revenu') | number }}</strong>
      </div>
      <div echarts [options]="optionsSparkline('revenu', '#f59e0b')" class="sparkline-chart"></div>
    </div>
  </div>
</section>

<!-- ═══════════ VISION GLOBALE ═══════════ -->
<section class="dash-section">
  <div class="dash-section-header">
    <div class="dash-section-title">
      <div class="dash-section-icon dash-section-icon--blue">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/>
        </svg>
      </div>
      <h3>Vision globale administrateur</h3>
    </div>
  </div>

  <div *ngIf="chargementVueGlobale" class="dash-loading">
    <div class="spinner"></div>
    <span>Chargement…</span>
  </div>

  <div *ngIf="!chargementVueGlobale && vueGlobale">

    <!-- Mini KPIs strip -->
    <div class="kpi-strip">
      <div class="kpi-tile kpi-tile--blue">
        <span class="kpi-tile-value">{{ vueGlobale.totalCommandesActives || 0 }}</span>
        <span class="kpi-tile-label">Commandes actives</span>
      </div>
      <div class="kpi-tile kpi-tile--red" [class.kpi-tile--alert]="(vueGlobale.incidentsOuverts || 0) > 0">
        <span class="kpi-tile-value">{{ vueGlobale.incidentsOuverts || 0 }}</span>
        <span class="kpi-tile-label">Incidents ouverts</span>
      </div>
      <div class="kpi-tile kpi-tile--slate">
        <span class="kpi-tile-value">{{ vueGlobale.totalIncidents || 0 }}</span>
        <span class="kpi-tile-label">Total incidents</span>
      </div>
      <div class="kpi-tile kpi-tile--purple">
        <span class="kpi-tile-value">{{ vueGlobale.manifestesEnCours || 0 }}</span>
        <span class="kpi-tile-label">Manifestes en cours</span>
      </div>
      <div class="kpi-tile kpi-tile--slate">
        <span class="kpi-tile-value">{{ vueGlobale.totalManifestes || 0 }}</span>
        <span class="kpi-tile-label">Total manifestes</span>
      </div>
    </div>

    <!-- Statuts + Zones -->
    <div class="global-detail-grid">

      <!-- Commandes par statut -->
      <div class="detail-card">
        <div class="detail-card-header">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
          </svg>
          <h4>Commandes par statut</h4>
        </div>
        <div class="statut-list">
          <div class="statut-row" *ngFor="let item of obtenirEntriesObjet(vueGlobale.commandesParStatut)">
            <span class="statut-dot" [style.background]="couleurStatutCommande(item.key)"></span>
            <span class="statut-name">{{ libelleStatutCommande(item.key) }}</span>
            <div class="statut-bar-wrap">
              <div class="statut-bar"
                [style.width.%]="item.value / totalCommandesStatut() * 100"
                [style.background]="couleurStatutCommande(item.key)">
              </div>
            </div>
            <span class="statut-count">{{ item.value }}</span>
          </div>
          <div class="statut-empty" *ngIf="obtenirEntriesObjet(vueGlobale.commandesParStatut).length === 0">
            Aucune donnée disponible
          </div>
        </div>
      </div>

      <!-- Zones départ + destination -->
      <div class="detail-card">
        <div class="detail-card-header">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
          </svg>
          <h4>Interurbain par zone</h4>
        </div>
        <div class="zone-tabs">
          <div class="zone-group">
            <span class="zone-group-label">Départ</span>
            <div class="zone-item" *ngFor="let item of obtenirEntriesObjet(vueGlobale.interurbainParZoneDepart)">
              <span class="zone-name">{{ item.key }}</span>
              <span class="zone-pill zone-pill--blue">{{ item.value }}</span>
            </div>
            <div class="zone-empty" *ngIf="obtenirEntriesObjet(vueGlobale.interurbainParZoneDepart).length === 0">—</div>
          </div>
          <div class="zone-divider"></div>
          <div class="zone-group">
            <span class="zone-group-label">Destination</span>
            <div class="zone-item" *ngFor="let item of obtenirEntriesObjet(vueGlobale.interurbainParZoneDestination)">
              <span class="zone-name">{{ item.key }}</span>
              <span class="zone-pill zone-pill--teal">{{ item.value }}</span>
            </div>
            <div class="zone-empty" *ngIf="obtenirEntriesObjet(vueGlobale.interurbainParZoneDestination).length === 0">—</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ═══════════ PARTENAIRES TRANSPORT ═══════════ -->
<section class="dash-section">
  <div class="dash-section-header">
    <div class="dash-section-title">
      <div class="dash-section-icon dash-section-icon--orange">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v4h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
      </div>
      <h3>Partenaires transport</h3>
    </div>
  </div>

  <div *ngIf="chargementPartenaires" class="dash-loading">
    <div class="spinner"></div>
    <span>Chargement…</span>
  </div>

  <div *ngIf="!chargementPartenaires && partenairesTransport" class="partenaires-grid">
    <div class="partenaire-tile">
      <div class="partenaire-tile-icon partenaire-tile-icon--blue">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22">
          <rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v4h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
      </div>
      <div class="partenaire-tile-body">
        <span class="partenaire-tile-value">{{ partenairesTransport.totalVehicules || 0 }}</span>
        <span class="partenaire-tile-label">Total véhicules</span>
        <span class="partenaire-tile-sub">dont {{ partenairesTransport.totalVehiculesPartenaires || 0 }} partenaires</span>
      </div>
    </div>
    <div class="partenaire-tile">
      <div class="partenaire-tile-icon partenaire-tile-icon--green">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
        </svg>
      </div>
      <div class="partenaire-tile-body">
        <span class="partenaire-tile-value">{{ (partenairesTransport.contratsMensuels || 0) + (partenairesTransport.contratsParLivraison || 0) }}</span>
        <span class="partenaire-tile-label">Contrats actifs</span>
        <span class="partenaire-tile-sub">{{ partenairesTransport.contratsMensuels || 0 }} mensuels · {{ partenairesTransport.contratsParLivraison || 0 }} à la livraison</span>
      </div>
    </div>
    <div class="partenaire-tile">
      <div class="partenaire-tile-icon partenaire-tile-icon--teal">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      </div>
      <div class="partenaire-tile-body">
        <span class="partenaire-tile-value">{{ partenairesTransport.totalLivraisonsMoisPartenaires || 0 }}</span>
        <span class="partenaire-tile-label">Livraisons ce mois</span>
        <span class="partenaire-tile-sub">{{ formaterMontant(partenairesTransport.montantTotalMoisPartenaires || 0) }} FCFA</span>
      </div>
    </div>
  </div>
</section>

<!-- ═══════════ ACTIVITÉ RÉCENTE ═══════════ -->
<section class="dash-section">
  <div class="dash-section-header">
    <div class="dash-section-title">
      <div class="dash-section-icon dash-section-icon--teal">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      </div>
      <h3>Activité récente</h3>
    </div>
    <a [routerLink]="['/commande/lister']" class="dash-link">Voir tout →</a>
  </div>

  <div *ngIf="chargementActivites" class="dash-loading">
    <div class="spinner"></div><span>Chargement…</span>
  </div>
  <div *ngIf="!chargementActivites && activitesRecentes.length === 0" class="dash-empty">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="32" height="32"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>
    <span>Aucune commande enregistrée</span>
  </div>
  <div *ngIf="!chargementActivites && activitesRecentes.length > 0" class="activite-list">
    <div class="activite-item" *ngFor="let activite of activitesRecentes.slice(0, 5)">
      <div class="activite-body">
        <div class="activite-top">
          <span class="activite-num">{{ activite.description }}</span>
          <span class="activite-statut" [ngClass]="'activite-statut--' + (activite.statut | lowercase)">{{ libelleStatutCommande(activite.statut) }}</span>
        </div>
        <div class="activite-bottom">
          <span class="activite-client">{{ activite.utilisateur }}</span>
          <span class="activite-sep">·</span>
          <span class="activite-date">{{ formaterDate(activite.date) }}</span>
          <span class="activite-montant" *ngIf="activite.montant > 0">{{ formaterMontant(activite.montant) }} FCFA</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ═══════════ ACTIONS RAPIDES ═══════════ -->
<section class="dash-section">
  <div class="dash-section-header">
    <div class="dash-section-title">
      <div class="dash-section-icon dash-section-icon--teal">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
        </svg>
      </div>
      <h3>Actions rapides</h3>
    </div>
  </div>
  <div class="quick-actions">
    <a [routerLink]="'/commande/enregistrer'" class="action-card action-card--teal">
      <span class="action-icon"><i class="fal fa-box-alt"></i></span>
      <div class="action-card-body">
        <span class="action-card-label">Nouvelle commande</span>
        <span class="action-card-desc">Enregistrer un envoi</span>
      </div>
      <i class="fal fa-chevron-right action-card-arrow"></i>
    </a>
    <a [routerLink]="'/utilisateur/enregistrerutilisateur'" class="action-card action-card--blue">
      <span class="action-icon"><i class="fal fa-user-plus"></i></span>
      <div class="action-card-body">
        <span class="action-card-label">Nouvel utilisateur</span>
        <span class="action-card-desc">Créer un compte</span>
      </div>
      <i class="fal fa-chevron-right action-card-arrow"></i>
    </a>
    <a [routerLink]="'/zone/enregistrer'" class="action-card action-card--purple">
      <span class="action-icon"><i class="fal fa-map-marker-alt"></i></span>
      <div class="action-card-body">
        <span class="action-card-label">Nouvelle zone</span>
        <span class="action-card-desc">Définir une zone</span>
      </div>
      <i class="fal fa-chevron-right action-card-arrow"></i>
    </a>
    <a [routerLink]="'/trajet/enregistrer'" class="action-card action-card--orange">
      <span class="action-icon"><i class="fal fa-route"></i></span>
      <div class="action-card-body">
        <span class="action-card-label">Nouveau trajet</span>
        <span class="action-card-desc">Créer un itinéraire</span>
      </div>
      <i class="fal fa-chevron-right action-card-arrow"></i>
    </a>
  </div>
</section>


<!-- ═══════════════════════════════════════════════════════════════════════
     SECTION : FLUX INTERURBAIN — Encaissements, Pipeline, Délais, Trajets
     ═══════════════════════════════════════════════════════════════════════ -->
<section class="interurbain-section" *ngIf="dashboardInterurbain && !chargementInterurbain">

  <div class="interurbain-header">
    <div class="interurbain-title-row">
      <span class="interurbain-badge">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v4h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
        Interurbain
      </span>
      <h2 class="interurbain-main-title">Tableau de bord interurbain</h2>
    </div>

    <div class="interurbain-kpis">
      <div class="ib-kpi ib-kpi-blue">
        <span class="ib-kpi-value">{{ dashboardInterurbain.totalCommandesInterurbaines }}</span>
        <span class="ib-kpi-label">Total envois</span>
      </div>
      <div class="ib-kpi ib-kpi-green">
        <span class="ib-kpi-value">{{ dashboardInterurbain.nbLivrees }}</span>
        <span class="ib-kpi-label">Livrées</span>
      </div>
      <div class="ib-kpi ib-kpi-purple">
        <span class="ib-kpi-value">{{ dashboardInterurbain.tauxSuccesPct }}%</span>
        <span class="ib-kpi-label">Taux de succès</span>
      </div>
      <div class="ib-kpi ib-kpi-orange">
        <span class="ib-kpi-value">{{ dashboardInterurbain.manifestesEnCours }}</span>
        <span class="ib-kpi-label">Manifestes actifs</span>
      </div>
      <div class="ib-kpi ib-kpi-red" *ngIf="dashboardInterurbain.nbIncidents > 0">
        <span class="ib-kpi-value">{{ dashboardInterurbain.nbIncidents }}</span>
        <span class="ib-kpi-label">Incidents</span>
      </div>
    </div>
  </div>

  <div class="interurbain-grid">

    <div class="ib-card ib-card-encaissement">
      <div class="ib-card-header">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
        <h4>Encaissements (30 derniers jours)</h4>
      </div>
      <div class="ib-encaiss-total">
        <span class="ib-encaiss-amount">
          {{ formaterMontant(dashboardInterurbain.encaissements?.totalEncaisseSurPeriode || 0) }} FCFA
        </span>
        <span class="ib-encaiss-sub">collectés</span>
      </div>
      <div class="ib-encaiss-warning" *ngIf="(dashboardInterurbain.encaissements?.montantAttenduNonEncaisse || 0) > 0">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        {{ formaterMontant(dashboardInterurbain.encaissements?.montantAttenduNonEncaisse) }} FCFA non encaissés
        <span class="ib-badge-warn">({{ dashboardInterurbain.encaissements?.nombreNonEncaisses }} commandes)</span>
      </div>
      <div class="ib-encaiss-modes">
        <div class="ib-mode-row" *ngFor="let entry of obtenirEntriesEncaissements()">
          <span class="ib-mode-name">{{ libelleModeEncaissement(entry.mode) }}</span>
          <div class="ib-mode-bar-wrap">
            <div class="ib-mode-bar"
              [style.width.%]="(dashboardInterurbain.encaissements?.totalEncaisseSurPeriode > 0)
                ? (entry.montant / dashboardInterurbain.encaissements.totalEncaisseSurPeriode * 100)
                : 0"
              [class.ib-mode-cash]="entry.mode === 'CASH'"
              [class.ib-mode-mm]="entry.mode === 'MOBILE_MONEY'"
              [class.ib-mode-virement]="entry.mode === 'VIREMENT'">
            </div>
          </div>
          <span class="ib-mode-amount">{{ formaterMontant(entry.montant) }} FCFA</span>
          <span class="ib-mode-count">× {{ entry.nombre }}</span>
        </div>
        <div class="ib-mode-row ib-mode-empty" *ngIf="obtenirEntriesEncaissements().length === 0">
          Aucun encaissement sur la période
        </div>
      </div>
      <div class="ib-encaiss-nonvalides" *ngIf="(dashboardInterurbain.encaissements?.nombreEncaissementsNonValides || 0) > 0">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        {{ dashboardInterurbain.encaissements.nombreEncaissementsNonValides }} encaissement(s) en attente de validation
      </div>
    </div>

    <div class="ib-card ib-card-pipeline">
      <div class="ib-card-header">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
        <h4>Pipeline de suivi</h4>
      </div>
      <div class="ib-pipeline-list">
        <div class="ib-pipeline-item" *ngFor="let entry of obtenirEntriesObjet(dashboardInterurbain.pipelineParStatut)">
          <span class="ib-pipeline-dot" [style.background]="couleurStatutInterurbain(entry.key)"></span>
          <span class="ib-pipeline-label">{{ libelleStatutInterurbain(entry.key) }}</span>
          <span class="ib-pipeline-count">{{ entry.value }}</span>
          <div class="ib-pipeline-bar">
            <div class="ib-pipeline-fill"
              [style.width.%]="dashboardInterurbain.totalCommandesInterurbaines > 0 ? (entry.value / dashboardInterurbain.totalCommandesInterurbaines * 100) : 0"
              [style.background]="couleurStatutInterurbain(entry.key)">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ib-card ib-card-delais">
      <div class="ib-card-header">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
        </svg>
        <h4>Délais moyens par zone de départ</h4>
      </div>
      <div class="ib-delais-list">
        <div class="ib-delai-row" *ngFor="let entry of obtenirEntriesObjet(dashboardInterurbain.delaisParZoneDepart)">
          <div class="ib-delai-info">
            <span class="ib-delai-zone">{{ entry.key }}</span>
            <span class="ib-delai-count">{{ entry.value.nombreLivraisons }} livraison(s)</span>
          </div>
          <span class="ib-delai-value"
            [class.ib-delai-fast]="entry.value.delaiMoyenHeures < 24"
            [class.ib-delai-medium]="entry.value.delaiMoyenHeures >= 24 && entry.value.delaiMoyenHeures < 48"
            [class.ib-delai-slow]="entry.value.delaiMoyenHeures >= 48">
            {{ formaterDelai(entry.value.delaiMoyenHeures) }}
          </span>
        </div>
        <div class="ib-delai-empty" *ngIf="(obtenirEntriesObjet(dashboardInterurbain.delaisParZoneDepart)).length === 0">
          Aucune donnée historique disponible
        </div>
      </div>
    </div>

    <div class="ib-card ib-card-trajets">
      <div class="ib-card-header">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
          <path d="M3 12h18M3 6h18M3 18h18"/>
        </svg>
        <h4>Top trajets</h4>
      </div>
      <div class="ib-trajets-list">
        <div class="ib-trajet-row" *ngFor="let t of (dashboardInterurbain.topTrajets || []); let i = index">
          <span class="ib-trajet-rank">{{ i + 1 }}</span>
          <div class="ib-trajet-route">
            <span class="ib-trajet-from">{{ t.zoneDepart }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
            <span class="ib-trajet-to">{{ t.zoneDestination }}</span>
          </div>
          <div class="ib-trajet-stats">
            <span class="ib-trajet-vol">{{ t.nombreLivraisons }} envois</span>
            <span class="ib-trajet-delai">⌀ {{ formaterDelai(t.delaiMoyenHeures) }}</span>
          </div>
        </div>
        <div class="ib-trajet-empty" *ngIf="!(dashboardInterurbain.topTrajets?.length)">
          Aucun trajet terminé pour le moment
        </div>
      </div>
    </div>

  </div>
</section>

<div class="ib-loading" *ngIf="chargementInterurbain">
  <div class="ib-spinner"></div>
  <span>Chargement des données interurbaines…</span>
</div>
